(async function() {
  // Get configuration from data attributes
  const container = document.getElementById('shopify-products-container');
  const BRAND_STORE_LINK = container.dataset.brandStoreLink || '';
  const BRAND_STORE_LINK_TEXT = container.dataset.brandStoreText || 'Visit Website';
  
  // Your Shopify store configuration
  const STOREFRONT_ACCESS_TOKEN = container.dataset.storefrontToken;
  const SHOP_DOMAIN = container.dataset.shopDomain;
  const collectionIdNumber = container.dataset.collectionId || '508630008088';
  const COLLECTION_ID = `gid://shopify/Collection/${collectionIdNumber}`;
  
  let COLLECTION_HANDLE = '';
  
  // Storefront API GraphQL query
  const query = `
    query getCollection($id: ID!) {
      collection(id: $id) {
        handle
        products(first: 6) {
          edges {
            node {
              id
              title
              description
              descriptionHtml
              handle
              availableForSale
              priceRange {
                minVariantPrice {
                  amount
                  currencyCode
                }
              }
              featuredImage {
                url(transform: {maxWidth: 600})
                altText
              }
              images(first: 4) {
                edges {
                  node {
                    url(transform: {maxWidth: 600})
                    altText
                  }
                }
              }
              variants(first: 10) {
                edges {
                  node {
                    id
                    title
                    availableForSale
                    quantityAvailable
                    currentlyNotInStock
                    selectedOptions {
                      name
                      value
                    }
                    price {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  // Fetch products from Shopify Storefront API
  async function fetchProducts() {
    const response = await fetch(`https://${SHOP_DOMAIN}/api/2024-01/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN
      },
      body: JSON.stringify({
        query: query,
        variables: {
          id: COLLECTION_ID
        }
      })
    });

    const data = await response.json();
    
    if (data.data?.collection?.handle) {
      COLLECTION_HANDLE = data.data.collection.handle;
    }
    
    return data.data.collection.products.edges;
  }

  // Format price
  function formatPrice(amount, currencyCode) {
    return `$${parseFloat(amount).toFixed(2)}`;
  }

  // Truncate text
  function truncateText(text, maxLength) {
    const stripped = text.replace(/<[^>]*>/g, '');
    if (stripped.length <= maxLength) return stripped;
    return stripped.substring(0, maxLength) + '...';
  }

  // Create Add to Cart button
  function createAddToCartButton(product, index) {
    const variantId = product.variants.edges[0]?.node.id;
    const buttonId = `add-to-cart-${index}`;
    
    return `
      <button class="product-form__submit button button--full-width button--primary add-to-cart-button" 
              data-variant-id="${variantId}"
              data-product-id="${product.id}"
              data-product-title="${product.title.replace(/"/g, '&quot;')}"
              data-product-price="${product.priceRange.minVariantPrice.amount}"
              data-product-image="${product.featuredImage?.url || ''}"
              data-product-handle="${product.handle}"
              data-button-id="${buttonId}">
        <span>Add to Cart</span>
      </button>
    `;
  }
  
function setupAddToCartButtons() {
  const buttons = document.querySelectorAll('.add-to-cart-button');
  buttons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      const productData = {
        variantId: this.dataset.variantId,
        productId: this.dataset.productId,
        title: this.dataset.productTitle,
        price: this.dataset.productPrice,
        image: this.dataset.productImage,
        handle: this.dataset.productHandle,
        shopDomain: SHOP_DOMAIN
      };
      
      const storeKey = SHOP_DOMAIN.replace(/\./g, '_');
      const storeCart = window.CustomCart?.[storeKey];

      if (storeCart && typeof storeCart.addToCart === 'function') {
        storeCart.addToCart(productData);

        const originalText = this.querySelector('span').textContent;
        this.querySelector('span').textContent = 'Added!';
        setTimeout(() => {
          this.querySelector('span').textContent = originalText;
        }, 1000);
      } else {
        console.error('CustomCart is not initialized. Make sure cart-manager.js is loaded before products-display.js');
        alert('Cart system not ready. Please refresh the page.');
      }
    });
  });
}

  function setupViewMoreButtons(products) {
  const buttons = document.querySelectorAll('.view-more-btn, .mobile-image-link, .select-option-button');
  buttons.forEach(button => {
    button.addEventListener('click', function(e) {
      const index = parseInt(this.dataset.productIndex);
      const product = products[index];

      const productData = {
        title: product.title,
        description: product.descriptionHtml,
        price: product.priceRange.minVariantPrice.amount,
        image: product.featuredImage?.url || '',
        secondImage: product.images.edges[1]?.node?.url || '',
        thirdImage: product.images.edges[2]?.node?.url || '',
        fourthImage: product.images.edges[3]?.node?.url || '',
        handle: product.handle,
        variants: product.variants.edges.map(e => ({
          id: e.node.id,
          title: e.node.title,
          availableForSale: e.node.availableForSale,
          options: e.node.selectedOptions, // e.g. [{name: "Size", value: "M"}]
          price: e.node.price?.amount
        })),
        productId: product.id,
        shopDomain: SHOP_DOMAIN,
        storefrontToken: STOREFRONT_ACCESS_TOKEN,
        availableForSale: product.availableForSale
      };

      localStorage.setItem(`product_${product.handle}`, JSON.stringify(productData));
      localStorage.setItem('productReferrer', window.location.href);
      localStorage.setItem('brandImage', container.dataset.brandImage || '');
    });
  });
}

  // Generate HTML for each product
  function createProductHTML(product, index) {
    const price = product.priceRange.minVariantPrice;
    const featuredImage = product.featuredImage;
    const secondImage = product.images.edges[1]?.node || featuredImage;
    const thirdImage = product.images.edges[2]?.node || featuredImage;
    const fourthImage = product.images.edges[3]?.node || featuredImage;
    const productUrl = `/pages/product-detail?product=${product.handle}`;
    const hasVariants = product.variants.edges.length > 1;
    const isAvailable = product.availableForSale;

    const selectedProductData = JSON.stringify({
      title: product.title,
      description: product.description,
      price: product.priceRange.minVariantPrice.amount,
      image: product.featuredImage?.url || '',
      secondImage: product.images.edges[1]?.node?.url || '',
      thirdImage: product.images.edges[2]?.node?.url || '',
      fourthImage: product.images.edges[3]?.node?.url || '',
      handle: product.handle,
      variants: product.variants.edges.map(e => ({
        id: e.node.id,
        title: e.node.title,
        availableForSale: e.node.availableForSale,
        options: e.node.selectedOptions, // e.g. [{name: "Size", value: "M"}]
        price: e.node.price?.amount
      })),
      productId: product.id,
      shopDomain: SHOP_DOMAIN,
      availableForSale: product.availableForSale
    }).replace(/'/g, "\\'");

    return `
      <div class="product-grid-item collection-product">
        <div class="grid-column">
          <div class="product-info">
            <h3>${product.title}</h3>
            <span class="product-price">
              <span class="product-price-text">${formatPrice(price.amount, price.currencyCode)}</span>
            </span>
            <p>${truncateText(product.description, 150)}</p>
            <span class="buy-button">
              ${
                !isAvailable
                  ? `<button class="product-form__submit button button--full-width button--primary" disabled><span>Sold Out</span></button>`
                  : hasVariants
                    ? `<a href="${productUrl}" class="product-form__submit button button--full-width button--primary select-option-button" data-product-index="${index}" style="text-align:center; text-decoration:none;">
                        <span>Select Options</span>
                      </a>`
                    : createAddToCartButton(product, index)
              }
            </span>
          </div>

          ${featuredImage ? `
            <div class="product-image main-product-image">
              ${
                product.availableForSale
                  ? `<a href="${productUrl}" class="mobile-image-link" data-product-index="${index}">
                      <img src="${featuredImage.url}" alt="${featuredImage.altText || product.title}" loading="lazy">
                     </a>`
                  : `<a href="${productUrl}" class="mobile-image-link" data-product-index="${index}" style="display: block; position: relative; height: 100%;">
                      <span class="sold-out-badge">SOLD OUT</span>
                      <img style="position: absolute;" src="${featuredImage.url}" alt="${featuredImage.altText || product.title}" loading="lazy">
                     </a>`
              }
            </div>
          ` : ''}
        </div>

        <div class="grid-column grid-column-desktop">
          <div class="lifestyle-image-container lifestyle-image-container-desktop">
            <a href="${productUrl}" class="view-more-btn" data-product-index="${index}">
              <div class="view-more-text">View more</div>
              <svg
                class="view-more-arrow"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                aria-hidden="true"
                focusable="false"
              >
                <path d="M8 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </a>
            <div class="product-image lifestyle-image lifestyle-image-desktop">
              ${secondImage ? `
                <img src="${secondImage.url}" alt="${secondImage.altText || product.title}" loading="lazy">
              ` : ''}
            </div>
            <div class="product-counter">
              <span class="product-counter-text">00${index + 1}</span>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  // Render products
  async function renderProducts() {
    try {
      const products = await fetchProducts();
      const container = document.getElementById('shopify-products-container');
      
      const productsHTML = products.map((edge, index) => {
        return createProductHTML(edge.node, index);
      }).join('');
      
      // Add the view collection button and brand store link at the end
      const additionalHTML = `
        <div class="view-collection-container">
          <a href="https://${SHOP_DOMAIN}/collections/${COLLECTION_HANDLE}" target="_blank" class="view-collection-button">
            <svg width="70" height="70" viewBox="0 0 80 80">
              <circle cx="40" cy="40" r="36" fill="none" stroke-width="1.5"/>
              <line x1="40" y1="28" x2="40" y2="52" stroke-width="2"/>
              <line x1="28" y1="40" x2="52" y2="40" stroke-width="2"/>
            </svg>
            <span class="view-collection-button-text">View More</span>
          </a>
        </div>
        ${BRAND_STORE_LINK ? `
        <div class="brand-store-link-container">
          <a
            href="${BRAND_STORE_LINK}"
            class="brand-store-link"
            target="_blank"
          >
            <div class="brand-store-link-wrapper">
              <span class="brand-store-link-text">${BRAND_STORE_LINK_TEXT}</span>
              <span class="brand-store-link-icon">
                <svg
                  class="square-arrow"
                  id="Layer_2"
                  data-name="Layer 2"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 150.25 150.75"
                >
                  <g id="Layer_1-2" data-name="Layer 1">
                    <g id="_7I9X5H.tif" data-name="7I9X5H.tif">
                      <g>
                        <polygon points="11.48 11.48 11.48 138.52 12.23 139.27 138.02 139.27 138.77 138.52 138.77 75.38 150.25 75.38 150.25 150.75 0 150.75 0 0 74.63 0 75.38 .75 75.38 10.73 74.63 11.48 11.48 11.48"/>
                        <polygon points="150.25 0 150.25 53.91 138.77 53.91 138.77 19.97 76.9 79.17 69.11 71.88 69.11 70.89 129.79 11.48 96.34 11.48 96.34 .75 97.09 0 150.25 0"/>
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
            </div>
          </a>
        </div>
        ` : ''}
      `;
      
      container.innerHTML = productsHTML + additionalHTML;
      
      // Setup Add to Cart button click handlers
      setupAddToCartButtons();

      // Setup View More button click handlers
      setupViewMoreButtons(products.map(e => e.node));
      
      // Initialize animations after HTML is rendered
      setTimeout(() => {
        if (typeof initializeAnimations === 'function') {
          initializeAnimations();
        }
      }, 100);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  }
  // Initialize
  renderProducts();
})();